var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.10658 2.55395L11 8.77934L19.8934 2.55395C19.728 2.22692 19.388 2 19 2H3C2.61204 2 2.27196 2.22692 2.10658 2.55395ZM20 4.92066L11.5735 10.8192C11.2291 11.0603 10.7709 11.0603 10.4265 10.8192L2 4.92066V15C2 15.5477 2.45228 16 3 16H19C19.5477 16 20 15.5477 20 15V4.92066ZM0 3C0 1.34772 1.34772 0 3 0H19C20.6523 0 22 1.34772 22 3V15C22 16.6523 20.6523 18 19 18H3C1.34772 18 0 16.6523 0 15V3Z",
    fill: "#202020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.10658 2.55395L11 8.77934L19.8934 2.55395C19.728 2.22692 19.388 2 19 2H3C2.61204 2 2.27196 2.22692 2.10658 2.55395ZM20 4.92066L11.5735 10.8192C11.2291 11.0603 10.7709 11.0603 10.4265 10.8192L2 4.92066V15C2 15.5477 2.45228 16 3 16H19C19.5477 16 20 15.5477 20 15V4.92066ZM0 3C0 1.34772 1.34772 0 3 0H19C20.6523 0 22 1.34772 22 3V15C22 16.6523 20.6523 18 19 18H3C1.34772 18 0 16.6523 0 15V3Z",
    fill: "url(#paint0_linear_122_263)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.10658 2.55395L11 8.77934L19.8934 2.55395C19.728 2.22692 19.388 2 19 2H3C2.61204 2 2.27196 2.22692 2.10658 2.55395ZM20 4.92066L11.5735 10.8192C11.2291 11.0603 10.7709 11.0603 10.4265 10.8192L2 4.92066V15C2 15.5477 2.45228 16 3 16H19C19.5477 16 20 15.5477 20 15V4.92066ZM0 3C0 1.34772 1.34772 0 3 0H19C20.6523 0 22 1.34772 22 3V15C22 16.6523 20.6523 18 19 18H3C1.34772 18 0 16.6523 0 15V3Z",
    fill: "url(#paint1_linear_122_263)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_122_263",
    x1: -4.86047,
    y1: -11.9302,
    x2: 11.7307,
    y2: 26.8235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAF6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19EDBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_122_263",
    x1: -4.86047,
    y1: -11.9302,
    x2: 11.7307,
    y2: 26.8235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAF6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005C46"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.2b263f67c913ceb5dcc3369295869d6f.svg";
export { ForwardRef as ReactComponent };